import styled, { keyframes } from 'styled-components';

const slideUp = keyframes`
  from { transform: translateY(100%); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
`;

export const Banner = styled.div`
  position: fixed;
  bottom: calc(56px + env(safe-area-inset-bottom, 0px) + 12px);
  left: 12px;
  right: 12px;
  z-index: 15;
  background: ${({ theme }) => theme.colors['neutral-0']};
  border: 2px solid ${({ theme }) => theme.colors['neutral-20']};
  border-radius: 12px;
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  animation: ${slideUp} 300ms cubic-bezier(0.2, 0.8, 0.4, 1);
  box-shadow: 0 8px 24px hsla(0, 0%, 0%, 0.16);
`;

export const IconWrapper = styled.div`
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: ${({ theme }) => theme.colors['secondary-20']};
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 28px;
    height: 28px;
  }
`;

export const Content = styled.div`
  flex: 1;
  min-width: 0;
`;

export const Title = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors['neutral-100']};
  line-height: 1.3;
`;

export const Subtitle = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors['neutral-60']};
  line-height: 1.3;
  margin-top: 2px;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

export const InstallButton = styled.button`
  padding: 8px 16px;
  background: ${({ theme }) => theme.colors['primary-60']};
  color: #ffffff;
  border: none;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  transition: background-color 200ms cubic-bezier(0.2, 0.8, 0.4, 1);
  -webkit-tap-highlight-color: transparent;

  &:active {
    background: ${({ theme }) => theme.colors['primary-50']};
  }
`;

export const DismissButton = styled.button`
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  color: ${({ theme }) => theme.colors['neutral-60']};
  cursor: pointer;
  border-radius: 8px;
  -webkit-tap-highlight-color: transparent;

  &:active {
    background: ${({ theme }) => theme.colors['neutral-20']};
  }

  svg {
    width: 18px;
    height: 18px;
  }
`;
